import CryptoJS from 'crypto-js'
import Cookies from 'js-cookie'

function setCookie(cName, value, expiredays) {
  // Encrypt，加密账号密码
  var encode = CryptoJS.AES.encrypt(value + '', 'secretkey123').toString()
  Cookies.set(cName, encode, { expires: expiredays })
}
// 读取cookie
function getCookie(cName) {
  let value = Cookies.get(cName)
  if (value === undefined) return ''
  var bytes = CryptoJS.AES.decrypt(value, 'secretkey123')
  return bytes.toString(CryptoJS.enc.Utf8)
}
// 清除cookie
function clearCookie(cName) {
  Cookies.set(cName, '', -1)
}
function clearAllCookie() {
  Cookies.set('', '', -1)
}

export default { setCookie, getCookie, clearCookie, clearAllCookie }



// WEBPACK FOOTER //
// ./src/plugin/cookies.js